import { useRef, useState, useEffect } from 'react'

import { v4 as uuidv4 } from 'uuid'

import classNames from 'classnames'

import styles from './team_grid.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'

function TeamGrid(props) {
	const teamGridRef = useRef(null)
	const fields = props.fields
	const [state, setState] = useState({items : fields.items.map(item => { return {...item, active: false} })})
	const uuidRef = useRef('team_grid-' + uuidv4())

	const handleItemClick = (e, index) => {
		e.stopPropagation()

		const gridItems = state.items
		gridItems.map(item => { return item.active = false })
		gridItems[index].active = true
		setState({items: gridItems})

		document.body.classList.add('overlay_open')
	}

	const handleCloseClick = (e, index) => {
		e.stopPropagation()

		const gridItems = state.items
		gridItems[index].active = false
		setState({items: gridItems})

		document.body.classList.remove('overlay_open')
	}

	useEffect(() => {
		const handleDocumentClick = (e) => {
			const activeItem = state.items.find(item => item.active)
			if (activeItem) {
				// Check if click is outside the overlay entirely
				const activeOverlay = teamGridRef.current?.querySelector(`.${styles.grid_item}.${styles.active} .${styles.overlay}`)
				if (activeOverlay && !activeOverlay.contains(e.target)) {
					const activeIndex = state.items.findIndex(item => item.active)
					if (activeIndex !== -1) {
						handleCloseClick(e, activeIndex)
					}
				}
			}
		}

		document.addEventListener('click', handleDocumentClick)
		return () => {
			document.removeEventListener('click', handleDocumentClick)
		}
	}, [state.items])

	return <div ref={teamGridRef}>
		<BlockWrapper {...props} fullbleed={props.accordionContent ? false : true} className={styles.team_grid}>
			<div className={styles.grid_wrapper}>
				{state.items && state.items.map((item, index) => {
					return <div key={uuidRef.current + '_' + index} className={classNames(styles.grid_item, item.active == true ? styles.active : '')}>
						<div className={styles.content} onClick={(e) => handleItemClick(e, index)}>
							{item.image.url &&							
								<Image className={`${styles.photo}`} {...item.image} settings={{texture: false}}/>
							}
							<h4 className={styles.name}>{item.name}</h4>
							<p className={styles.position}>{item.position}</p>
							<div className={styles.link}>View Bio</div>
						</div>
						<div className={styles.overlay}>
							<button className={styles.close} onClick={(e) => handleCloseClick(e, index)}></button>
							<div className={styles.content_wrapper}>
								{item.image.url &&
									<Image className={styles.photo} {...item.image} />
								}	
								<div className={styles.content}>
									<h4 className={styles.name}>{item.name}</h4>
									<p className={styles.position}>{item.position}</p>
									<div className={styles.biography}>{item.biography}</div>
								</div>
							</div>
						</div>
					</div>
				})}
			</div>
		</BlockWrapper>
	</div>
}

export default TeamGrid